import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import { OrdersPage } from './OrdersPage';
import { OrderEditorPage } from './OrderEditorPage';
import { OrderDetailPage } from './OrderDetailPage';
import { PipelinePage } from './PipelinePage';
import { PlanningPage } from './PlanningPage';
import type { BackofficeModule } from '../registry';

/** Baustein für die Anfrage: Auftrag direkt aus der Anfrage (KON-238) */
export { InquiryOrderButton } from './InquiryOrder';

/** Bausteine für andere Seiten: Aufträge beim Kontakt und bei der Aufgabe, der Link vom Angebot auf seinen Auftrag */
export { RelatedOrders, OfferOrderLink } from './RelatedOrders';

/**
 * Einstiegspunkt des Moduls „Aufträge“ im Backoffice (KON-035). Alles dazu liegt in diesem Ordner. Das Backoffice kennt nur diese Datei (siehe registry.tsx).
 * Die Verträge zur API stehen in packages/shared/src/orders, Positionen und Summen kommen aus dem Modul Angebote.
 */
export const ordersModule: BackofficeModule = {
  key: 'orders',
  path: '/auftraege',
  // Hauptmodul der Abteilung „Aufträge“: das Cockpit über den ganzen Ablauf und die Liste. Die Auftragsplanung gehört zum Personalmanagement (group), sie steht hinter den Schichten.
  nav: [
    { label: 'Auftragsübersicht', path: '/auftragscockpit' },
    { label: 'Alle Aufträge', path: '/auftraege' },
    { label: 'Auftragsplanung', path: '/auftragsplanung', permission: 'orders.plan', group: 'team', after: 'shifts' },
  ],
  routes: (
    <>
      <Route path="auftragscockpit" element={<ModuleGate module="orders" permission="orders.read"><PipelinePage /></ModuleGate>} />
      <Route path="auftragsplanung" element={<ModuleGate module="orders" permission="orders.plan"><PlanningPage /></ModuleGate>} />
      <Route path="auftraege" element={<ModuleGate module="orders" permission="orders.read"><OrdersPage /></ModuleGate>} />
      <Route path="auftraege/neu" element={<ModuleGate module="orders" permission="orders.write"><OrderEditorPage /></ModuleGate>} />
      <Route path="auftraege/:id" element={<ModuleGate module="orders" permission="orders.read"><OrderDetailPage /></ModuleGate>} />
      <Route path="auftraege/:id/bearbeiten" element={<ModuleGate module="orders" permission="orders.write"><OrderEditorPage /></ModuleGate>} />
    </>
  ),
};
